import styled from "styled-components";
import image from '../../Images/mailist.jpg'


export const MailingHP = styled.div`

background-position:center;
background-size: cover;
background-repeat: no-repeat;
height: 100vh;
object-fit: cover;
overflow:hidden;
`
export const MailText = styled.h1`
color:#000;
font-family: monospace;
justify-content:center;
text-align:center;
margin-bottom:10rem;
position: relative;
font-weight:bolder
`